module.exports = __webpack_public_path__ + "static/media/tr.def734e9.svg";